import React from 'react';

import { Switch as ChakraSwitch } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledSwitch = styled(ChakraSwitch)`
  & .chakra-switch__track {
    background-color: #ebeff3;
    width: 36px;
    height: 20px;
    box-sizing: border-box;
    outline: none;
    box-shadow: none;
  }
  & .chakra-switch__track[data-focus] {
    outline: none;
    box-shadow: none;
  }
  & .chakra-switch__track[data-disabled] {
    opacity: 1;
    background-color: ${(props) => props.theme.colors.functional.F5F7F9};
  }
  & .chakra-switch__track[data-checked] {
    background: ${(props) => props.theme.colors.functional['1565BC']};
  }

  & .chakra-switch__thumb {
    width: 16px;
    height: 16px;
    background-color: white !important;
  }

  & .chakra-switch__thumb[data-checked] {
    transform: translateX(16px);
  }
`;

export const Switch = (props) => <StyledSwitch {...props} colorScheme="red" />;
